import {
  WebsocketOnlineOfflineStatusChangeEvent,
  WebsocketOnlineOfflineSubscribeEvent,
} from '../websocket/server-message-event.model';
import { OnlineOfflineStatus } from './online-offline.model';

export function transformOnlineOfflineStatusFetch<
  T extends keyof WebsocketOnlineOfflineSubscribeEvent['data']
>(
  [userId, status]: [T, WebsocketOnlineOfflineSubscribeEvent['data'][T]],
): OnlineOfflineStatus {
  return {
    id: userId,
    status,
  };
}

export function transformOnlineOfflineStatusChange(
  data: WebsocketOnlineOfflineStatusChangeEvent['data'],
): OnlineOfflineStatus {
  return {
    id: data.user.toString(),
    status: data.to,
  };
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/online-offline/online-offline.transformers.ts